module.exports = __webpack_public_path__ + "static/media/trump.f13e5c08.png";